export type SaebComparisonTrend = 'up' | 'down' | 'same';

export interface SaebComparisonMessage {
  trend: SaebComparisonTrend;
  heading: string;
  text: string;
}

// Reading Cycle comparison is based on the number of correct answers, not the
// 0-500 score (the score is no longer shown to the student).
function questionsLabel(value: number): string {
  return value === 1 ? 'questão' : 'questões';
}

export default function getSaebComparisonMessage(
  previousCorrect: number,
  currentCorrect: number,
): SaebComparisonMessage {
  const delta = currentCorrect - previousCorrect;

  if (delta > 0) {
    return {
      trend: 'up',
      heading: 'Parabéns, você evoluiu!',
      text: `Você acertou ${delta} ${questionsLabel(
        delta,
      )} a mais que na sua primeira atividade. O trabalho na trilha apareceu no seu resultado.`,
    };
  }

  if (delta < 0) {
    const absDelta = Math.abs(delta);
    return {
      trend: 'down',
      heading: 'Continue firme na leitura',
      text: `Desta vez você acertou ${absDelta} ${questionsLabel(
        absDelta,
      )} a menos que na sua primeira atividade. Isso acontece: siga praticando e volte ao texto antes de responder.`,
    };
  }

  return {
    trend: 'same',
    heading: 'Você manteve o seu resultado',
    text: 'Você acertou a mesma quantidade de questões da sua primeira atividade. Você seguiu no mesmo ritmo de leitura.',
  };
}
